import { axios } from '@/services/axios';

export const createEngine = (engineData) => {
    return axios.post('/engine', engineData);
};
